import { controls, currencyToNumber, grouped } from "../../controls";


const salary_dedications = {
  label: "Salary Dedications",
  starting: true,
  url: "salary_dedications",
  pageLabel: "Salary Dedications",
  pageType: "history",
  filter: [

    ...controls.magicDateLabel({ tab: "general", label: "Month", target: "month", star: true }),
    ...controls.magicDate({ tab: "general", name: "salary_month", dateType: "monthYear", isRequired: true, isReadOnly: "edit", displayFormat: "MMMM yyyy" }),
    ...controls.displayText({ tab: "general", label: "" }),
    
       ...controls.displayText({
      tab: "filter", label: "Bank",
      width: "col-sm-2"
    }),
    ...controls.autoComplete({
      tab: "filter", name: "bank_code", controlType: "Bank", width: "col-sm-2",
    }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" })
    
   ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "Salary Dedications",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    filterable: true,
    sortable: true,
    // defaultsTo: 0,
    pivot: true,
    extraRows: {
      location: "top",
      fields: ["amount","bank_loan",],
    
    },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
     
      {
        Header: "A/c No",
        accessor: "employee_code",
      },
      {
        Header: "Name",
        accessor: "employee_display",
      },
      {
        Header: "Amount",
        accessor: "amount",
        type: "currency"
      },
      {
        Header: "Bank Loan",
        accessor: "bank_loan",
        type: "currency"
      },
    
    ]
  }
};

export default salary_dedications;